import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, message,InputNumber, Tooltip } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../config/api-connect';
import * as Styled from './style.js';

import './style.css'
import { FaAngleDoubleLeft } from "react-icons/fa";


const { Option } = Select;

const AddJob = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [submitLoading, setSubmitLoading] = useState(false);
  const location = useLocation();
  const departments = location.state?.departments || [];

  const handleAddJob = async () =>{
    setSubmitLoading(true);

    const values = await form.validateFields();
   
    const url = `${getLocationOrigin()}/career/add_job/`;
    const options = {...defaultOptions};
    options['headers'] = {'content-type': 'application/json'}
    options['method'] = 'POST';   
    options['body'] = JSON.stringify(values);
    
    return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(response => {
          if(response.message == 'Job Created Successfully'){
            message.success(response.message);
            navigate('/careers'); 
          }
          else  
            message.error(response.message)
            setSubmitLoading(false)
          })
        .catch(error => {
          console.log(error.message)
          setSubmitLoading(false)
        });
  }

  return (
    <Styled.MainContainer>
      <Styled.Header>
        <Tooltip title="Back"><a style={{cursor: 'pointer',color:'#02475c'}} onClick={()=>navigate(-1)}><FaAngleDoubleLeft/> </a></Tooltip>
        <div>Add New Job</div>
        <span></span>
      </Styled.Header>

      <Styled.FormContainer>
        <Styled.FormBody>
          <Form
            form={form}
            layout="vertical"
            style={{
              width: "100%",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            <Form.Item name="title" label="Title" rules={[{ required: true }]}>
              <Input style={{ borderRadius: '4px' }} />
            </Form.Item>

            <Form.Item name="location" label="Location" rules={[{ required: true }]}>
              <Input style={{ borderRadius: '4px' }} />
            </Form.Item>

            <Form.Item name="description" label="Description">
              <Input.TextArea rows={3} style={{ borderRadius: '4px' }} />
            </Form.Item>

            <Form.Item name="contact_email" label="Email">
              <Input style={{ borderRadius: '4px' }} />
            </Form.Item>

            <Form.Item name="contact_no" label="Contact No" rules={[{ required: true }]}>
              <Input style={{ borderRadius: '4px' }} />
            </Form.Item>

            <Form.Item name="minimum_qualification" label="Minimum Qualification">
              <Input style={{ borderRadius: '4px' }} />
            </Form.Item>

            <Form.Item name="experience" label="Experience">
              <Input style={{ borderRadius: '4px' }} />
            </Form.Item>

            <Form.Item name="department" label="Department" rules={[{ required: true }]}>
              <Select placeholder="Select Department" allowClear>
                {departments.map((dept) => (
                  <Option key={dept.value} value={dept.value}>{dept.label}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="no_of_openings" label="No of Openings" rules={[{ required: true }]}>
              <InputNumber min={0} style={{ borderRadius: '4px', width: '100%' }}/>
            </Form.Item>

            <Form.Item style={{ textAlign: 'right' }}>
              <Button type="primary" onClick={handleAddJob} loading={submitLoading} style={{ borderRadius: '4px', backgroundColor: '#006d77', borderColor: '#3c6e71' }}>
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Styled.FormBody>
      </Styled.FormContainer>

    </Styled.MainContainer>
  );
};

export default AddJob;
